/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import * as yup from 'yup';
/**
 * Add visual form validation rules are mentioned here
 */
export const addVisualValidation = yup.object().shape({
  name: yup.string().trim().required('Visual name is a required field'),
  report: yup
    .object()
    .shape({
      id: yup.string().required('id is required'),
      label: yup.string().required('label is required'),
    })
    .nullable()
    .required('Report is a required field'),
  page: yup
    .object()
    .shape({
      id: yup.string().required('id is required'),
      label: yup.string().required('label is required'),
    })
    .nullable()
    .required('Page is a required field'),
  order: yup.number().required('Order is a required field').min(0),
  description: yup.string().optional().default(''),
  tags: yup.array().min(1, 'At least one tag is required'),
  agentGuidance: yup.array().of(
    yup.object().shape({
      prompt: yup.string().required('Prompt is required'),
      tag: yup.array().optional()
    }).optional()
  ),
});
/**
 * Update visual form validation rules are mentioned here
 */
export const updateVisualValidation = yup.object().shape({
  name: yup.string().trim().required('Visual name is a required field'),
  order: yup.number().required('Order is a required field').min(0),
  tags: yup.array().min(1, 'At least one tag is required'),
  description: yup.string().optional().default(''),
    agentGuidance: yup.array().of(
    yup.object().shape({
      prompt: yup.string().required('Prompt is required'),
      tag: yup.array().optional()
    }).optional()
  ),
});
